import type { ReactNode } from 'react';
import { Text, UnstyledButton } from '@mantine/core';

export default function HrefButton({
  href,
  children,
}: {
  href: string;
  children: ReactNode;
}) {
  return (
    <UnstyledButton onClick={() => window.open(href, '_blank')}>
      <Text
        size="sm"
        fw={400}
        lh={1.15}
        lineClamp={1}
        c="blue"
        td="underline"
        style={{
          display: 'inline-block',
          fontVariantNumeric: 'tabular-nums',
          transition: 'color 120ms ease',
        }}
        styles={{
          root: {
            textDecoration: 'none',
          },
        }}
      >
        {children}
      </Text>
    </UnstyledButton>
  );
}
